<div class="alerta-fundo" *ngIf="aberto" role="alertdialog" aria-modal="true" aria-labelledby="titulo-alerta-chat">
  <section class="alerta-modal">
    <header class="faixa">
      <span class="sirene" aria-hidden="true">
        <nb-icon icon="alert-triangle"></nb-icon>
      </span>
      <div class="faixa-texto">
        <p class="urgencia">Atenção imediata</p>
        <h2 id="titulo-alerta-chat">Chat parado</h2>
      </div>
      <span class="total-badge">{{ alertas.length }}</span>
    </header>

    <div class="corpo">
      <section class="grupo" *ngIf="alertasNovas.length">
        <header class="grupo-cabecalho grupo-nova">
          <h3>Pergunta nova, ainda não iniciada</h3>
          <span class="grupo-contagem">{{ alertasNovas.length }}</span>
        </header>
        <article class="item item-nova" *ngFor="let alerta of alertasNovas">
          <div class="item-topo">
            <span class="tipo-badge tipo-badge-nova">Nova</span>
            <span class="atraso">{{ textoAtraso(alerta) }}</span>
          </div>
          <strong class="titulo">{{ alerta.titulo || 'Pergunta' }}</strong>
          <p class="quem">{{ alerta.nomeCliente }} · {{ alerta.nomeExecutivo }}</p>
          <p class="motivo">{{ rotuloMotivo(alerta) }}<span *ngIf="desde(alerta)"> · desde {{ desde(alerta) }}</span></p>
          <button nbButton status="danger" (click)="abrir(alerta)" [disabled]="clienteLinkCarregandoId === alerta.conversaId">
            Abrir cliente
          </button>
        </article>
      </section>

      <section class="grupo" *ngIf="alertasPendenteRetorno.length">
        <header class="grupo-cabecalho grupo-andamento">
          <h3>Pendente de retorno do operacional</h3>
          <span class="grupo-contagem">{{ alertasPendenteRetorno.length }}</span>
        </header>
        <article class="item item-andamento" *ngFor="let alerta of alertasPendenteRetorno">
          <div class="item-topo">
            <span class="tipo-badge tipo-badge-andamento">Sem resposta</span>
            <span class="atraso">{{ textoAtraso(alerta) }}</span>
          </div>
          <strong class="titulo">{{ alerta.titulo || 'Pergunta' }}</strong>
          <p class="quem">{{ alerta.nomeCliente }} · {{ alerta.nomeExecutivo }}</p>
          <p class="operacional-responsavel" *ngIf="alerta.nomeOperacional">
            Operacional: <strong>{{ alerta.nomeOperacional }}</strong>
          </p>
          <p class="motivo">{{ rotuloMotivo(alerta) }}<span *ngIf="desde(alerta)"> · último registro {{ desde(alerta) }}</span></p>
          <button nbButton status="danger" (click)="abrir(alerta)" [disabled]="clienteLinkCarregandoId === alerta.conversaId">
            Abrir cliente
          </button>
        </article>
      </section>

      <section class="grupo" *ngIf="alertasSemRetorno.length">
        <header class="grupo-cabecalho grupo-sem-retorno">
          <h3>Sem retorno do executivo ou sem encerrar</h3>
          <span class="grupo-contagem">{{ alertasSemRetorno.length }}</span>
        </header>
        <article class="item item-sem-retorno" *ngFor="let alerta of alertasSemRetorno">
          <div class="item-topo">
            <span class="tipo-badge tipo-badge-sem-retorno">Parada</span>
            <span class="atraso">{{ textoAtraso(alerta) }}</span>
          </div>
          <strong class="titulo">{{ alerta.titulo || 'Pergunta' }}</strong>
          <p class="quem">{{ alerta.nomeCliente }} · {{ alerta.nomeExecutivo }}</p>
          <p class="operacional-responsavel" *ngIf="alerta.nomeOperacional">
            Operacional: <strong>{{ alerta.nomeOperacional }}</strong>
          </p>
          <p class="motivo">{{ rotuloMotivo(alerta) }}<span *ngIf="desde(alerta)"> · última resposta {{ desde(alerta) }}</span></p>
          <button nbButton status="danger" (click)="abrir(alerta)" [disabled]="clienteLinkCarregandoId === alerta.conversaId">
            Abrir cliente
          </button>
        </article>
      </section>
    </div>

    <footer class="rodape">
      <p>Confirme só depois de ver. Se continuar parado, o aviso volta no prazo.</p>
      <button nbButton status="basic" (click)="dispensar()">Entendi</button>
    </footer>
  </section>
</div>
